import React, { Component } from 'react';
import Breadcrumbs from 'react-breadcrumbs';
import Header from './layout/Header';
import Footer from './layout/Footer';
import Sidebar from './layout/Sidebar';

class App extends Component {
  render() {
    return (
      <div className="wrapper">
        <Header />
        <Sidebar />
        <div className="content-wrapper">
          <section className="content-header">
            <h1 id="titulo">{this.props.routes[this.props.routes.length-1]['name'] || 'Protocolo Web'}</h1>
            <Breadcrumbs routes={this.props.routes} params={this.props.params} wrapperElement="ol" itemElement="li" wrapperClass="breadcrumb" itemClass="" separator="" />
          </section>
          <section className="content">
            {this.props.children}
          </section>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/modulos/App.js